export default __webpack_public_path__ + "static/media/step3Plwd.71769448.png";